import { AppConstant } from "../config";

interface IHourFormatterArguments {
  valueType: "minutes" | "seconds" | "units";
  fractionDigits: number;
  textFormat?: "hrs" | "hours";
}

function getTimeInMinutes(
  time: number,
  valueType: IHourFormatterArguments["valueType"]
) {
  switch (valueType) {
    case "seconds":
      return time / 60;
    case "units":
      return time * AppConstant.OneUnit;
    default:
      return time;
  }
}

function hourFormatter(time: number, options: IHourFormatterArguments): string {
  const { textFormat, fractionDigits, valueType } = options;
  const timeInMinutes = getTimeInMinutes(time, valueType);
  let formattedHour: string = "";
  let hour = timeInMinutes / 60;
  hour = Number(hour.toFixed(fractionDigits));

  switch (textFormat) {
    case "hours":
      formattedHour = hour + (hour > 1 ? " hours" : " hour");
      break;
    case "hrs":
      formattedHour = hour + (hour > 1 ? " hrs" : " hr");
      break;
    default:
      formattedHour = hour.toString();
  }

  return formattedHour;
}

const formatDecimalHoursToHM = (hours: number) => {
  // Round to nearest minute to avoid floating point issues
  const totalMinutes = Math.round(hours * 60);
  const wholeHours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${wholeHours}h ${minutes}m`;
};

export const TimeUtility = {
  hourFormatter,
  formatDecimalHoursToHM,
};
